<div *ngIf="!containsError">
  <div>
     <span class="pageHeader" id="updateSeasonedLoanFeesHeader">

									Update Seasoned Loan Fees
								</span>

  </div>
  <br><br>
  <div class="error-container" *ngIf="showErrorDiv">
    <p>{{errHeading}}</p>
    <p>
       <li *ngIf="selNumErrBoo"> {{selNumErrMessage}}</li>
       <li *ngIf="conNumErrBoo"> {{conNumErrMessage}}</li>
    </p>
  </div>
  <div *ngIf="displayMess">
    <div class="successMessAlign">
        {{rssSuccMess}}
    </div>
  </div>
  <div class="indicates">
    <span class="EMBRequiredControl">+</span><span class="EMBMessageCue"> Indicates
	            required information</span>
  </div><br>
  <span class="adminTblAlign">
        <span class="ui-g-3 lblAlign"><label class="EMBRequiredControl"> + &nbsp; </label> Seller Number:	 </span>

        <div class="ui-g-3">
          <div *ngIf="!editModeSel">{{selNumber}}</div>
          <div *ngIf="editModeSel"><input type="text" ng-show="editMode" [(ngModel)]='selNumber'  maxlength="9"
                                          fmTextInput></div>  </div>
      </span>
  <span class="adminTblAlign">
         <div class="ui-g-3 lblAlign"> Contract Number:	 </div>
         <div class="ui-g-3">
           <div *ngIf = "!editModeConNum">{{contractNumber}}</div>
           <div *ngIf = "editModeConNum"><input type="text" [(ngModel)]='contractNumber'  maxlength="6" fmTextInput>
           </div>
         </div>
  </span>
  <span class="adminTblAlign" *ngIf='isLoanFeeAvail'>
         <div class="ui-g-3 lblAlign"> Seasoned Loan Fee Unit Amount:	 </div>
         <div class="ui-g-3">
           <div *ngIf = "!editLoanFee">{{loanFee   | number : '1.2-2'}} </div>
            <div *ngIf = "editLoanFee">
              <input type="text" [ngModel]='loanFee ' (ngModelChange)="loanFee=$event" name="inputField" step="0.01" ng-pattern="/^[0-9]+(\.[0-9]{1,2})?$/"   fmTextInput>
            </div>
         </div>
  </span>
  <div class="btnAlign">
    <div *ngIf="isSearch">
      <button fmButton type="button" [small]="true" [primary]="true" label="Search" (click)="search()"
              class="dispbuttonMargin"></button>
    </div>
    <div *ngIf="isUpdate">
      <button fmButton type="button" [small]="true" [primary]="true" label="Update" (click)="updateLoanFee()"
              class="dispbuttonMargin"></button>
    </div>
    <div *ngIf="isAdd">
      <button fmButton type="button" [small]="true" label="Add" (click)="addLoanFee()"
              class="dispbuttonMargin"></button>
    </div>
    <div *ngIf="isSave">
      <button fmButton type="button" [small]="true" label="Save" (click)="saveLoanFee()"
              class="dispbuttonMargin"></button>
    </div>
    <div *ngIf="isConfirmDel">
      <button fmButton type="button" (click)="ConfirmDelete()" [small]="true" label="Confirm"
              class="dispbuttonMargin"></button>
    </div>
    <div *ngIf="isDelete">
      <button fmButton type="button" [small]="true" label="Delete" (click)="deleteLoanFee()"
              class="dispbuttonMargin"></button>
    </div>
    <div *ngIf="isCanMain">
      <button fmButton type="button" routerLink="/admin" [small]="true" label="Cancel"
              class="dispbuttonMargin"></button>
    </div>
    <div *ngIf="isCanLoc">
      <button fmButton type="button" (click)="cancelLocal()" [small]="true" label="Cancel"
              class="dispbuttonMargin"></button>
    </div>

  </div>
</div>
<app-error-page [errorMsg]="errorMsg" *ngIf="containsError"></app-error-page>
